import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  Stack,
  Collapse,
  Button,
  Divider,
  Grid,
} from '@mui/material';
import {
  Business as BusinessIcon,
  LocationOn as LocationIcon,
  AccountBalance as TaxIcon,
  CorporateFare as SharesIcon,
  ExpandMore,
  ExpandLess,
  CheckCircle,
  Warning,
  Error,
} from '@mui/icons-material';

const iconMap = {
  business: <BusinessIcon fontSize="small" color="primary" sx={{ mr: 1 }} />,
  location: <LocationIcon fontSize="small" color="primary" sx={{ mr: 1 }} />,
  tax: <TaxIcon fontSize="small" color="primary" sx={{ mr: 1 }} />,
  shares: <SharesIcon fontSize="small" color="primary" sx={{ mr: 1 }} />,
};

const DetailCard = ({
  title,
  icon,
  items,
  footer,
  variant = 'normal',
  expandableSection,
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Card
      variant="outlined"
      sx={{
        mb: 3,
        ...(variant === 'inner' && {
          boxShadow: 'none',
          border: '1px solid rgba(0, 0, 0, 0.12)',
          backgroundColor: 'background.default',
        }),
      }}
    >
      <CardContent>
        {title && (
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              display: 'flex',
              alignItems: 'center',
              fontWeight: 'bold',
            }}
          >
            {icon && iconMap[icon]}
            {title}
          </Typography>
        )}

        <Grid container spacing={2}>
          {items.map((item, index) => (
            <Grid item xs={item.fullWidth ? 12 : 6} key={index}>
              {item.label && (
                <Typography variant="subtitle2" color="text.secondary">
                  {item.label}
                </Typography>
              )}
              {item.isArray ? (
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ mt: 1, flexWrap: 'wrap', gap: 1 }}
                >
                  {item.value.map((code, i) => (
                    <Chip key={i} label={code} size="small" />
                  ))}
                </Stack>
              ) : (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {item.status === 'success' && (
                    <CheckCircle
                      sx={{ color: 'success.main', mr: 1, fontSize: '1rem' }}
                    />
                  )}
                  {item.status === 'warning' && (
                    <Warning
                      sx={{ color: 'warning.main', mr: 1, fontSize: '1rem' }}
                    />
                  )}
                  {item.status === 'error' && (
                    <Error
                      sx={{ color: 'error.main', mr: 1, fontSize: '1rem' }}
                    />
                  )}
                  <Typography
                    variant="body2"
                    sx={{
                      ...(item.status === 'error' && { color: 'error.main' }),
                      wordBreak: 'break-word',
                    }}
                  >
                    {item.value}
                  </Typography>
                </Box>
              )}
            </Grid>
          ))}
        </Grid>

        {footer && <Box sx={{ mt: 2 }}>{footer}</Box>}

        {expandableSection && (
          <>
            <Divider sx={{ my: 2 }} />
            <Button
              size="small"
              onClick={() => setExpanded(!expanded)}
              endIcon={expanded ? <ExpandLess /> : <ExpandMore />}
              sx={{ color: 'text.secondary' }}
            >
              {expanded ? 'Show Less' : 'Show More'}
            </Button>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <Box sx={{ mt: 2 }}>{expandableSection}</Box>
            </Collapse>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default DetailCard;
